import React, { useCallback, ReactElement } from "react";
import { memo } from "react";

// internal-deps
import { AriaHidden, useEffectOnce } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { isEmpty } from "@swiggy-private/js-utils";

//styles
import styles from "./RxInstructions.scss";

// widgets
import RestaurantInstructionsEditIcon from "@cart-ui/widgets/restaurant-instructions-edit-icon";

// test-ids
import { RX_INSTRUCTIONS_TEST_IDS } from "@swiggy-private/cart-test-ids";

// constants
import {
    DEFAULT_RX_INSTRUCTIONS_PLACEHOLDER,
    RX_INSTRUCTIONS_MAX_LINES,
} from "@cart-ui/constants/RxSpecialInstructions";

export interface RxInstructionsProps {
    rxInstruction: string;
    onClick: VoidFunction;
    onImpression: VoidFunction;
}

function RxInstruction(props: RxInstructionsProps): React.ReactElement<RxInstructionsProps> {
    const { rxInstruction, onClick } = props;

    useEffectOnce(() => {
        props.onImpression();
    });

    const renderIcon = useCallback((): ReactElement | null => {
        return (
            <AriaHidden as="span" className={styles.icon}>
                <RestaurantInstructionsEditIcon data-testid={RX_INSTRUCTIONS_TEST_IDS.ICON} />
            </AriaHidden>
        );
    }, []);

    return (
        <div className={styles.container} onClick={onClick} data-testid={RX_INSTRUCTIONS_TEST_IDS.CONTAINER}>
            <div className={styles.content} data-testid={RX_INSTRUCTIONS_TEST_IDS.TEXT}>
                <Text variant="V2.body2.neutral.medium" maxLines={RX_INSTRUCTIONS_MAX_LINES}>
                    {!isEmpty(rxInstruction) ? rxInstruction : DEFAULT_RX_INSTRUCTIONS_PLACEHOLDER}
                </Text>
                {renderIcon()}
            </div>
        </div>
    );
}

export default memo(RxInstruction);
